/**
 * TokenService - Centralized token management with localStorage/sessionStorage persistence
 */

const TOKEN_KEY = 'upscaler_token';

class TokenService {
  /**
   * Set the authentication token
   * @param token - The token to store
   * @param stayLoggedIn - If true, store in localStorage (survives F5). If false, use sessionStorage.
   */
  setToken(token: string, stayLoggedIn: boolean): void {
    const storage = stayLoggedIn ? localStorage : sessionStorage;
    storage.setItem(TOKEN_KEY, token);

    // Clear from the other storage to avoid conflicts
    if (stayLoggedIn) {
      sessionStorage.removeItem(TOKEN_KEY);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  }

  /**
   * Get the current token from storage (checks both localStorage and sessionStorage)
   */
  getToken(): string | null {
    // Check localStorage first (persistent login)
    const fromLocal = localStorage.getItem(TOKEN_KEY);
    if (fromLocal) {
      return fromLocal;
    }

    // Fall back to sessionStorage
    const fromSession = sessionStorage.getItem(TOKEN_KEY);
    return fromSession || null;
  }

  /**
   * Clear the token from storage
   */
  clearToken(): void {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
  }

  /**
   * Check if a token exists
   */
  hasToken(): boolean {
    return this.getToken() !== null;
  }
}

export const tokenService = new TokenService();
